import { ImpactType } from '../impact';

export type RetirementStatus = 'pending' | 'completed';

export const isCarbonType = (impactType: ImpactType) =>
  [ImpactType.CARBON_OFFSETS, ImpactType.CARBON_REMOVAL].includes(impactType);

export type BespokeRetirementLineItem = {
  id: number;
  type: ImpactType;
  projectName: string;
  quantity: number;
  registryLink: string | null;
};

export type BespokeRetirementInvoice = {
  userId: string;
  customerId: number;
  impactOrderId: number;
  invoiceRef: string;
  retirementName: string;
  retirementReason?: string;
  raisedBy?: string;
  consumptionPeriodStart?: string;
  consumptionPeriodEnd?: string;
  retirementDeadline?: string;
  notes?: string;
  paidAt: string | null;
  items: BespokeRetirementLineItem[];
};

export type RetirementDetails = {
  retirementName: string;
  retirementReason?: string;
  raisedBy?: string;
  consumptionPeriodStart?: string;
  consumptionPeriodEnd?: string;
  retirementDeadline?: string;
  notes?: string;
};
